 <template>
    <div>
        <login-form :isAdmin="isAdmin"></login-form>
    </div>
</template>
<script>
    import LoginForm from '../layouts/partials/auth/LoginForm.vue';
    export default {
        components: {
            'login-form': LoginForm
        },
        data() {
            return {
                isAdmin: false
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>